module.exports = __webpack_public_path__ + "static/media/swiss-post.eee2c7d2.svg";